// document.addEventListener("DOMContentLoaded", function () {
//     const lenis = new Lenis({
//         duration: 1.2, // scroll speed
//         easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easing function
//         smooth: true
//     });

//     function raf(time) {
//         lenis.raf(time);
//         requestAnimationFrame(raf);
//     }

//     requestAnimationFrame(raf);
// });
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

$(document).on('click', '.myth-item', function(){
  var $this = $(this);
  if ($this.hasClass('active')) {
    $this.removeClass('active');
  } else {
    $('.myth-item').removeClass('active');
    $this.addClass('active');
  }
});

$(document).on('click', '.tab-panel_accordion_title', function () {
  var $this = $(this);
  if ($this.hasClass('active')) {
    $this.removeClass('active');
    $this.siblings('.tab-panel_accordion_content').slideUp();
  } else {
    $('.tab-panel_accordion_title').removeClass('active');
    $('.tab-panel_accordion_content').slideUp();
    $this.addClass('active');
    $this.siblings('.tab-panel_accordion_content').slideDown();
  }
});


var swiper = new Swiper(".key_box_main_swiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop:false,
  pagination: false,
  navigation: {
    nextEl: ".key_box_main_swiper .swiper-button-next",
    prevEl: ".key_box_main_swiper .swiper-button-prev",
  },
});

var swiper2 = new Swiper(".diffrence-column_wrp.mb_show", {
  slidesPerView: 1,
  spaceBetween: 15,
  loop:false,
  pagination: false,
  navigation: {
    nextEl: ".diffrence-column_wrp .swiper-button-next",
    prevEl: ".diffrence-column_wrp .swiper-button-prev",
  },
});

var swiper3 = new Swiper(".pdp-steps_wrp.mb_show", {
  slidesPerView: 1,
  spaceBetween: 15,
  loop:false,
  pagination: false,
  navigation: {
    nextEl: ".pdp-steps_wrp .swiper-button-next",
    prevEl: ".pdp-steps_wrp .swiper-button-prev",
  },
});

var swiper4 = new Swiper(".treasure-box_premium_swiper", {
  slidesPerView: 2,
  spaceBetween: 11,
  loop: false,
  grabCursor: true,
  navigation: {
    nextEl: '.treasure-box_premium_swiper .nav-arrow.next', 
    prevEl: '.treasure-box_premium_swiper .nav-arrow.prev',
  },
  pagination: {
    el: ".treasure-box_premium_swiper .swiper-pagination",
    type: "progressbar"
  },
  breakpoints: {
    1200: {
      slidesPerView: 4.1,
      spaceBetween: 20,
    },
    990: {
      slidesPerView: 3.1,
      spaceBetween: 20,
    },
    750: {
      slidesPerView: 2.1,
      spaceBetween: 20,
    },
  },
});


let cart_swiper;
function initCartSwiper() {
  if (cart_swiper) {
    cart_swiper.destroy(true, true);
  }
   const ct_cart_swiper = new Swiper(".cart_product_list", {
      spaceBetween: 10,
      slidesPerView: 1.8,
      navigation: false,
      pagination: false,
      grabCursor: true,
      breakpoints: {
        750: {
          slidesPerView: 2.8,
          spaceBetween: 15,
        },
      },
    });
}
initCartSwiper();

// after product info scroll fixed atc dispaly js start

// document.addEventListener("DOMContentLoaded", () => {
//   const infoWrapper = document.querySelector(".product__info-wrapper");
//   const atcBlock = document.querySelector(".atc_main_box");

//   if (!infoWrapper || !atcBlock) return;

//   atcBlock.style.display = "none";

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting) {
//         atcBlock.style.display = "none";
//       } else {
//         atcBlock.style.display = "block";
//       }
//     },
//     {
//       threshold: 0.1
//     }
//   );
//   observer.observe(infoWrapper);
// });
document.addEventListener("DOMContentLoaded", () => {
  const infoWrapper = document.querySelector(".product__info-wrapper");
  const atcBlock = document.querySelector(".atc_main_box");

  if (!infoWrapper || !atcBlock) return;

  let hasScrolled = false;
  let scrollTimeout;

  // ✅ Show at start
  atcBlock.style.display = "block";

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!hasScrolled) return; // ❌ don't run on load

      if (entry.isIntersecting) {
        atcBlock.style.display = "none"; // main CTA visible
      } else {
        atcBlock.style.display = "block"; // main CTA hidden
      }
    },
    { threshold: 0.2 }
  );

  observer.observe(infoWrapper);

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY;

    // ✅ Top → always show
    if (scrollTop < 50) {
      atcBlock.style.display = "block";
      return;
    }

    // ✅ First scroll behavior
    if (!hasScrolled) {
      hasScrolled = true;

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        atcBlock.style.display = "none";
      }, 300); // smooth delay
    }
  });
});

// after product info scroll fixed atc dispaly js end




